<template>
  <div id="channel-baskets">
    <div class="vx-row mb-6">
      <div class="vx-col w-full mb-2">
        <router-link
          :to="{ path: '/ChannelBaskets/AddBasket' }"
          class="vs-component vs-button bg_l_green"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("InsertNewBasket") }}
        </router-link>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
            <vs-tab :label="$t('InOrder')" class="mt-1">
              <in-order
                :tabIndex="0"
                v-if="isRender[0]"
                :numberRowsPerPage="numberRowsPerPage"
              ></in-order>
            </vs-tab>
            <vs-tab :label="$t('ReviewQueue')" class="mt-1">
              <review-queue
                :tabIndex="1"
                v-if="isRender[1]"
                :numberRowsPerPage="numberRowsPerPage"
              ></review-queue>
            </vs-tab>
            <vs-tab :label="$t('Processing')" class="mt-1">
              <processing
                :tabIndex="2"
                v-if="isRender[2]"
                :numberRowsPerPage="numberRowsPerPage"
              ></processing>
            </vs-tab>

            <vs-tab :label="$t('Sending')" class="mt-1">
              <sending
                :tabIndex="3"
                v-if="isRender[3]"
                :numberRowsPerPage="numberRowsPerPage"
              ></sending>
            </vs-tab>
            <vs-tab :label="$t('Sent')" class="mt-1">
              <sent
                :tabIndex="4"
                v-if="isRender[4]"
                :numberRowsPerPage="numberRowsPerPage"
              ></sent>
            </vs-tab>
            <vs-tab :label="$t('Delivered')" class="mt-1">
              <delivered
                :tabIndex="5"
                v-if="isRender[5]"
                :numberRowsPerPage="numberRowsPerPage"
              ></delivered>
            </vs-tab>
            <vs-tab
              :label="$t('IgnoredOrdersPischargePermission')"
              class="mt-1"
            >
              <ignored-orders-discharge-permission
                :tabIndex="6"
                v-if="isRender[6]"
                :numberRowsPerPage="numberRowsPerPage"
              ></ignored-orders-discharge-permission>
            </vs-tab>
            <vs-tab :label="$t('IgnoredOrders')" class="mt-1">
              <ignored-orders
                :tabIndex="7"
                v-if="isRender[7]"
                :numberRowsPerPage="numberRowsPerPage"
              ></ignored-orders>
            </vs-tab>
            <vs-tab :label="$t('AllOrders')" class="mt-1">
              <all-orders
                :tabIndex="8"
                v-if="isRender[8]"
                :numberRowsPerPage="numberRowsPerPage"
              ></all-orders>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#channel-baskets .vs-tabs--li button.vs-tabs--btn {
  padding: 10px 5px !important;
}
</style>
<script>
import InOrder from "./InOrder/Index.vue";
import ReviewQueue from "./ReviewQueue/Index.vue";
import Processing from "./Processing/Index.vue";
import IgnoredOrders from "./IgnoredOrders/Index.vue";
import IgnoredOrdersDischargePermission from "./IgnoredOrdersDischargePermission/Index.vue";
import Sending from "./Sending/Index.vue";
import Sent from "./Sent/Index.vue";
import Delivered from "./Delivered/Index.vue";
import AllOrders from "./AllOrders/Index.vue";

export default {
  name: "basketManagement_ChannelBaskets_Index",
  components: {
    InOrder,
    ReviewQueue,
    Processing,
    IgnoredOrders,
    IgnoredOrdersDischargePermission,
    Sending,
    Sent,
    Delivered,
    AllOrders
  },
  data() {
    return {
      isRender: [],
      referencePageInfo: {},
      numberRowsPerPage: "",
      tabIndex: 0
    };
  },

  mounted() {
    this.onRender = Array(9).fill(false);
    setTimeout(() => {
      if (this.$route.query.referencePageInfo) {
        this.referencePageInfo = this.$route.query.referencePageInfo;
        this.$refs.Tabs.value = this.referencePageInfo.tabIndex;
        this.numberRowsPerPage = this.referencePageInfo.numberRowsPerPage;
      }
      this.isRender = Array(9).fill(true);
    }, 150);
  }
};
</script>
